<template>
    <div class="filterContainer" v-show="!hideFilters || hasVisibleWidgets || hasRelocatedContent">
        <actionCodeInput class="hideInMobile" v-if="!filtersOnly && this.displayActionCodeInput && !$store.state.pointshop"></actionCodeInput>
        <pointShopWidget ref="pointWidget" v-if="!filtersOnly && this.$root.pointshop"></pointShopWidget>
        <div class="categoryContainer" v-show="!hideFilters">
            <div v-for="(attr, index) in attrs" :key="index">
                <transition name="btn-fade">
                 
                    <div :class="[hideCategories.includes(attr.attributeId) ? 'openCat' : '']">
                        <p @click="hideShow(attr.attributeId)">
                            {{ attr.attribute }}
                            <span
                              v-if="showCounts && checkedCount(attr) > 0"
                              class="catFilterCount"
                            >{{ checkedCount(attr) }}</span>
                            <i
                              :class="hideCategories.includes(attr.attributeId) ? 'far fa-angle-right' : 'far fa-angle-down'"
                            ></i>
                        </p>
                        <transition name="slide">
                            <div class="categories" v-if="!hideCategories.includes(attr.attributeId)">
                                <ul>
                                    <li :class="[value.checked ? 'checked' : '']" v-for="(value, index2) in attr.values" :key="index2"><input v-model="value.checked" @change="submitChangeToFilter(value, value.checked)" :id="value.attributeValueId" type="checkbox"><label :for="value.attributeValueId">{{value.name}}</label></li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </transition>
            </div>
        </div>
    
        <div class="legalInfoContainer" v-if="!filtersOnly && !hideFilters && this.$root.language.wsm_legalInfoHeading !='false'">
            <p class="legalInfoHeading" v-html="this.$root.language.wsm_legalInfoHeading"></p>
            <p class="legalInfoBody" v-html="this.$root.language.wsm_legalInfoBody"></p>
        </div>

        <!-- Host for CMS nodes moved from .product-left-box (see App.vue relocateProductLeftBox) -->
        <div
          v-if="!filtersOnly"
          ref="relocatedLeftBox"
          class="relocatedLeftBox"
        ></div>
    
    
       
    
    
    </div>
</template>

<script>
import actionCodeInput from "./actionCodeInput.vue"
import pointShopWidget from "./../../../pointshop-widget/src/Pointshop-code-insert.vue"

export default {
    props: {
        // When true, shows a badge with the number of active filters per category.
        // Used in the mobile drawer; disabled on desktop sidebar.
        showCounts: {
            type: Boolean,
            default: false,
        },
        // When true, only renders the filter categories — hides pointShopWidget,
        // actionCodeInput, and legalInfo. Used in the mobile drawer.
        filtersOnly: {
            type: Boolean,
            default: false,
        },
        // When true, hides the filter categories — only shows widgets and legal info.
        // Used on the mobile sidebar so widgets still appear outside the drawer.
        hideFilters: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        actionCodeInput,
        pointShopWidget: () => window.isPointShop ?
           import ('./../../../pointshop-widget/src/Pointshop-code-insert.vue') : '',
    },
    data() {
        return {
            attrs: [],
            hideCategories: [],
            preLoadFilter: {
                query: [],
                filterObjects: [],
            },
            loaded: false,
            showActionCodeInput: ['en_IE', 'de_DE'],
            hasRelocatedContent: false,
        }
    },
    async mounted() {
        if (window.location.hash.length > 0) {
            this.getUrlParameters()
        }
        
        await axios.get(window.basedir + '/ajaxRequestServlet?mode=AttributeValues&isSearchable=false&isWebAttribute=true&isOnProducts=true').then(response => {
            this.attrs = response.data.attributes
            this.attrs.forEach(element => {
                element.values.forEach(element => {
                    if (this.preLoadFilter.query.includes(element.name)) {
                        this.$set(element, 'checked', true);
                        this.preLoadFilter.filterObjects.push(element)
                    } else {
                        this.$set(element, 'checked', false)
                    }
                })
            });
            //mobile stuff
            if (this.$parent.mobile) {
                response.data.attributes.forEach(cat => {
                    this.hideCategories.push(cat.attributeId)
                })
            }
        }).then(() => {
            this.preLoadFilter.filterObjects.forEach(filterObj => {
                this.submitChangeToFilter(filterObj, true)
            })
        })
        this.$store.subscribe((mutation, state) => {
            switch (mutation.type) {
                case 'applySearchResult':
                    this.attrs.forEach(attr => {
                        attr.values.forEach(value => {
                            if (state?.filter?.includes(value.attributeValueId)) {
                                this.$set(value, 'checked', true)
                            } else {
                                this.$set(value, 'checked', false)
                            }
                        })
                    })
                    break;
                case 'setFilter':
                    this.attrs.forEach(attr => {
                        attr.values.forEach(value => {
                            if (state?.filter?.includes(value.attributeValueId)) {
                                this.$set(value, 'checked', true)
                            } else {
                                this.$set(value, 'checked', false)
                            }
                        })
                    })
                    break;
            }
        })
    },
    computed:{
        locale: function() {
            return window.locale
        },
        displayActionCodeInput: function(){
            return this.showActionCodeInput.includes(this.locale)
        },
        // True when there are widgets to show (pointshop, action code input).
        // Used to keep the container visible on mobile even when filters are hidden.
        hasVisibleWidgets: function(){
            return !this.filtersOnly && (this.$root.pointshop || (this.displayActionCodeInput && !this.$store.state.pointshop))
        }
    },
    methods: {
        checkedCount: function(attr) {
            return attr.values.filter(function(v) { return v.checked }).length;
        },
        getUrlParameters: function() {
            var filter;
            var parser = document.createElement('a'); //Create a container
            parser.href = window.location.href; //Get the whole URL
            var parameter = parser.hash; //search for parameter
            var value = parser.hash;
            parameter = parameter.substr(parameter.indexOf("#") + 1);
            parameter = parameter.substr(0, parameter.indexOf('='));
            if (parameter == 'filter') {
                filter = value.substr(value.indexOf("=") + 1); //Get value of filter=VALUE
                filter = decodeURI(filter); //Decode URI
                filter = filter.split("&");
                filter.forEach((el, index) => {
                    filter[index] = el.replaceAll('-', ' ').replaceAll('_', '&');
                })
                this.preLoadFilter.query = filter;
            }
        },
        submitChangeToFilter: function(val, checked) {
            var checkedArray = [];
            this.attrs.forEach(attr => {
                attr.values.forEach(value => {
                    if (value.checked) {
                        checkedArray.push(value.attributeValueId)
                    }
                })
            })
            if (this.$root.settings.showFilter && checkedArray.length > 0) {
                this.$store.state.searchResult.result = [{ globalProducts: [] }];
                this.$store.state.searchResult.show = false;
                this.$store.dispatch("getPriceList", [checkedArray, this.$root.settings.hideCat]); //pass the blacklisted array as the second array
            } else {
                this.$store.dispatch("getPriceList", [checkedArray, this.$root.settings.hideCat]); //pass the blacklisted array as the second array
            }
            if (this.$store.state.priceListFilterPills.includes(val) && !checked) {
                var index = this.$store.state.priceListFilterPills.indexOf(val);
                this.$store.state.priceListFilterPills.splice(index, 1);
            } else {
                this.$store.state.priceListFilterPills.push(val)
                    gtag('event', 'Shop search Category', {
                        event_category: 'engagement',
                        event_label: val.name,
                    })
            }
        },
        hideShow: function(index) {
            if (this.hideCategories.includes(index)) {
                this.hideCategories = this.hideCategories.filter(function(e) {
                    return e !== index
                })
            } else {
                this.hideCategories.push(index)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.filterContainer {
    float: left;
    .headlineFilter {
        font-size: 1.2em;
        font-weight: bold;
        padding: 2%;
        padding-left: 3%;
        color: white;
        background: #004570;
        margin: 0;
    }
    .categoryContainer {
        &>div>div {
            margin-bottom: 21px;
            border-radius: 4px;
        }
        .openCat {
            p {
                border-radius: 4px;
            }
        }
        p {
            background: #004570;
            color: white;
            padding: 3%;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            cursor: pointer;
            margin-bottom: 0;
            display: flex;
            align-items: center;
            &:hover {
                background: #035080;
            }
            i {
                margin-left: auto;
                color: white;
            }
            .catFilterCount {
                background: #7caf63;
                color: white;
                font-size: 0.75em;
                font-weight: 700;
                min-width: 20px;
                height: 20px;
                border-radius: 10px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                margin-left: 8px;
                padding: 0 6px;
            }
        }
        .categories {
            border: 1px solid #d5d5d5;
        }
    }
    .relocatedLeftBox {
        margin-top: 21px;
        text-align: left;
        width: 100%;
    }
    .legalInfoContainer {
        .legalInfoHeading {
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            background-color: #004570;
            border: 1px solid #004570;
            color: white;
            padding: 3%;
            margin: 0;
        }
        .legalInfoBody {
            padding: 5% 3% 9%;
            border: 1px solid #d5d5d5;
        }
    }
}


.productShopMoble {
    .filterContainer {
        width: 100%;
    }
}

ul {
    padding: 5px;
}

li {
    list-style-type: none;
    background: none;
    text-align: left;
    padding-left: 0;
    margin-top: 1px;
    margin-bottom: 4px;
    cursor: pointer;
    width: 100%;
    min-height: 28px;
    &:hover {
        background: #cbe9fc;
    }
    input[type='checkbox'] {
        cursor: pointer;
        margin-top: 0;
        vertical-align: middle;
    }
    label {
        cursor: pointer;
        vertical-align: middle;
        width: 87% !important;
        margin-top: 0px;
        position: relative;
        display: inline-block !important;
        font-size: 0.85em;
        font-weight: 600;
        word-break: break-word;
        min-height: 22px;
        padding-top: 4px;
    }
}

.checked {
    background: #cbe9fc;
    border-radius: 4px;
    width: 100%;
}

.btn-fade-enter-active,
.btn-fade-leave-active {
    transition: all 0.3s ease;
}

.btn-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */

    {
    transform: translateY(10px);
    opacity: 0;
}

.btn-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */

    {
    transform: translateY(10px);
    opacity: 0;
}

.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
    max-height: 800px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
    margin-top: 0 !important;
}

.turquoiseTheme {
    .filterContainer {
        .categoryContainer {
            p {
                background: #418a90;
            }
        }
    }
}
</style>